import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=8cbc17b8&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbc17b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cbc17b8')) {
      api.createRecord('8cbc17b8', component.options)
    } else {
      api.reload('8cbc17b8', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=8cbc17b8&scoped=true&", function () {
      api.rerender('8cbc17b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/DataTable.vue"
export default component.exports